<script lang="ts">
    import RewardsCurrency from "@apps/rewards/components/RewardsCurrency.svelte";
    import type { GiftCardRewardEntity } from "@apps/rewards/entities/entities";
    import type RewardsCurrencyFormatter from "@apps/rewards/lib/RewardsCurrencyFormatter";
    import type HTMLSanitizerInterface from "@modules/money/HTMLSanitizer/HTMLSanitizerInterface";

    type GiftCardReward<T = boolean> = T extends true
        ? GiftCardRewardEntity
        : Omit<GiftCardRewardEntity, "code" | "balance">;

    export let reward: GiftCardReward;
    export let currencyFormatter: RewardsCurrencyFormatter;
    export let sanitizer: HTMLSanitizerInterface;
</script>

<RewardsCurrency
    let:amount
    amount={reward.initialValue}
    {currencyFormatter}
    {sanitizer}
>
    <slot reward={{ reward, formattedAmount: amount }} />
</RewardsCurrency>
